/**
 * @author radejdong
 * @class
 * @name Goods
 * @description  物品相关
 */

import { initEnv } from '@tencent/pmd-tools/lib/env';
import { dateFormat } from '@tencent/pmd-tools/lib/time';
import { getConfig } from '@tencent/pmd-config';
import { getName, GAME_PVP } from '@tencent/pmd-tools/lib/game';
import get from 'lodash-es/get';
import { formatGoodsStatusText, formatUsedGoodsStatusText } from '../game/button-game';
import { jumpToPageCommon } from 'src/component/logic/tip-merchant/jump-handle/helper';

const DEFAULT_GOODS_ICON = 'https://game.gtimg.cn/images/user/cp/a20190402wifiTQ/myStuff0710/wzrs-whiteState.png';

function getGoodsBasicInfo(water, goods) {
  goods.picurl = (water.goodscfg.goodsicon && water.goodscfg.goodsicon.length > 0)
    ? water.goodscfg.goodsicon : DEFAULT_GOODS_ICON;
  goods.brand_logo = water.goodscfg.extra?.goods_brand_info?.brand_logo;
  goods.name = water.goodscfg.goodsname;
  goods.benefit_tag = (water.goodscfg.extra && water.goodscfg.extra.benefit_tag) ? water.goodscfg.extra.benefit_tag : '';
}

function getGoodsProvider(water, goods) {
  if (initEnv().isInGame && water?.gid === GAME_PVP && water?.extrainfo?.source === 'star_member') {
    goods.provider = '<span style="color:#F5B74C">星会员积分兑换</span>';
  } else if (water?.goodscfg?.extra?.goods_brand_info) {
    goods.provider = water.goodscfg.extra.goods_brand_info.brand_name;
    goods.brandId = water.goodscfg.extra.goods_brand_info.brand_id;
  } else if (water.goodscfg.provider) {
    goods.provider = water.goodscfg.provider;
  } else if (water.goodscfg.merchant) {
    goods.provider = water.goodscfg.merchant.storename + water.goodscfg.merchant.addr;
  } else {
    goods.provider = getName(water.gid);
  }
}

const parserWaterGoods = function (water) {
  const goods = {
    originWater: water,
  };
  if (water && water.winningtime) {
    goods.winningtime = `${water.winningtime ? water.winningtime : ''}-${water.orderid ? water.orderid : ''}`;
    goods.gotoGoodDetail = gotoGoodDetail;
    goods.giftid = water.giftid;
    goods.displaytype = get(water, 'goodscfg.displaytype');

    if (water.goodscfg) {
      // 获取基本信息
      getGoodsBasicInfo(water, goods);

      // 获取provider
      getGoodsProvider(water, goods);

      // 获取进阶礼包
      if (water.goodscfg.extra && water.goodscfg.extra.cycgift) {
        goods.extraGiftName = water.goodscfg.extra.cycgift.name;
        goods.extraGiftImg = water.goodscfg.extra.cycgift.gift_pic;
      }
      if (water.goodscfg.extra && water.goodscfg.extra.treasure_cfg) {
        goods.chooseGift = water.goodscfg.extra.choose_treasure === 1;
        goods.giftList = water.goodscfg.extra.treasure_cfg.gift_list;
      }

      if (water.overduetime) {
        const gid = app.tip_gid || getConfig('game.gid');
        if (gid == 411) {
          goods.deadline = `有效期至${formatTime(water.overduetime)}`;
        } else {
          goods.deadline = `兑换有效期至${formatTime(water.overduetime)}`;
        }
        goods.overduetime = water.overduetime;
        if (water.status === 4) {
          // 处理x天内过期提示
          const dayAfterOneTimeStamp = Math.round(new Date(new Date().setHours(24, 0, 0, 0)) / 1000);
          const dayAfterTwoTimeStamp = Math.round(new Date(new Date().setHours(24, 0, 0, 0)) / 1000) + 86400 * 1;
          const dayAfterThreeTimeStamp = Math.round(new Date(new Date().setHours(24, 0, 0, 0)) / 1000) + 86400 * 2;
          const gid = app.tip_gid || getConfig('game.gid');
          if (water.overduetime < dayAfterOneTimeStamp && gid !== 331) {
            goods.overdueTip = '今日到期';
          } else if (water.overduetime < dayAfterTwoTimeStamp && gid !== 331) {
            goods.overdueTip = '明日到期';
          } else if (water.overduetime < dayAfterThreeTimeStamp && gid !== 331) {
            goods.overdueTip = '3天后到期';
          }
        }
      } else {
        goods.deadline = '永久有效';
      }

      // 4:立即兑换 2:已兑换 6:已过期 7:待发货 8:已发货
      // 特殊处理下实物奖励
      if (water.goodscfg.displaytype === 5 && water.status === 2) {
        goods.status = !water.cdkey || water.cdkey.length === 0 ? 7 : 8;
        goods.statusText = !water.cdkey || water.cdkey.length === 0 ? '待发货' : '已发货';
        goods.statusStyle = !water.cdkey || water.cdkey.length === 0 ? 'primary' : 'delivered';
      } else {
        goods.status = water.status === 4 ? 4 : water.status === 2 ? 2 : 6;
        // 此处和老窝与tracy确认，已使用样式改回delivered
        goods.statusStyle = water.status === 4 ? 'primary' : water.status === 2 ? 'delivered' : 'disabled';
        goods.statusText = water.status === 4 ? formatGoodsStatusText() : water.status === 2 ? formatUsedGoodsStatusText() : '已过期';
      }

      if (water.status === 4
        && (water.goodscfg.displaytype === 25 || water.goodscfg.displaytype === 26 || water.goodscfg.displaytype === 28)
        && !!water.cdkey) {
        goods.statusText = '立即查看';
      }

      // cycGiftId，判断核销状态，非0：商家券、需要核销
      if (water.goodscfg.extra && water.goodscfg.extra.cycgift) {
        goods.cycGiftId = water.goodscfg.extra.cycgift.giftid;
      }
      // 16，就是游戏礼包。此时，展示所属游戏名称即可
      if (water.goodscfg.goodstype === 16) {
        goods.provider = getName(water.gid);
        goods.benefit_tag = '';
      }
    }
  }
  return goods;
};

const formatTime = function (timestamp) {
  timestamp = timestamp || 0;
  if (timestamp !== 0) {
    return dateFormat(new Date(timestamp * 1000), 'yyyy.MM.dd');
  }
  return '不限';
};

const gotoGoodDetail = function (winningtime) {
  jumpToPageCommon({ path: `/goods/detail/${winningtime}` });
};

export default {
  parserWaterGoods,
  formatTime,
  gotoGoodDetail,
  getGoodsBasicInfo,
  getGoodsProvider,
  DEFAULT_GOODS_ICON,
};

export {
  parserWaterGoods,
  formatTime,
  gotoGoodDetail,
  getGoodsBasicInfo,
  getGoodsProvider,
  DEFAULT_GOODS_ICON,
};
